"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const RadioHolder = _styledComponents.default.div.withConfig({
  displayName: "Radio__RadioHolder",
  componentId: "design-system__sc-1ff38ba-0"
})(["input{display:none;}label{background-color:", ";border:8px solid ", ";box-shadow:0 0 0 2px #979797;border-radius:100%;width:12px;height:12px;display:block;cursor:pointer;}input:checked + label{background-color:", ";}input:disabled + label{border-color:", ";background-color:", ";cursor:auto;}input:disabled:checked + label{background-color:#979797;}"], _BaseTheme.default.colors.white, _BaseTheme.default.colors.white, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.inputDisabledGray, _BaseTheme.default.colors.inputDisabledGray);

const Radio = _ref => {
  let {
    id,
    name,
    onChange,
    defaultChecked,
    value,
    register
  } = _ref,
      props = _objectWithoutProperties(_ref, ["id", "name", "onChange", "defaultChecked", "value", "register"]);

  return /*#__PURE__*/_react.default.createElement(RadioHolder, null, /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "radio",
    name: name,
    id: id,
    value: value,
    onChange: onChange,
    defaultChecked: defaultChecked,
    ref: register
  }, props)), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }));
};

Radio.propTypes = {
  id: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  name: _propTypes.default.string,
  value: _propTypes.default.string,
  defaultChecked: _propTypes.default.bool,
  register: _propTypes.default.func
};
Radio.defaultProps = {
  onChange: undefined,
  name: undefined,
  value: '',
  defaultChecked: false,
  register: () => {}
};
var _default = Radio;
exports.default = _default;